import {useTranslation} from "react-i18next";
import {useDispatch, useSelector} from "react-redux";
import {generatePath, useNavigate, useParams, useSearchParams} from "react-router-dom";
import React, {useCallback, useEffect, useMemo, useState} from "react";
import {
  getQuestionAnswerAction,
  getQuestionAnswerActionFail, testBegin, testBeginFail, testEnd,
  testResultAction
} from "../../../../store/pages/plans/actions";
import {RootState} from "../../../../store";
import {selectStore} from "../../../../store/selector";
import {MyBreadcrumb, MyButton, MyText, Timer} from "../../../../components";
import {
  Alert,
  Badge,
  Button,
  Card,
  Checkbox,
  Col,
  Flex,
  Form,
  Input,
  message,
  Modal,
  Popover,
  Radio,
  Row,
  TabPaneProps
} from "antd";
import {TabsStyles} from "../../../Plans/[ctpId]/[lessonId]/tests/index.styles";
import {setFormAction} from "../../../../store/common/actions";
import {ROUTE_PATH} from "../../../../constants";
import {Color} from "../../../../themes";
import {MDXEditorMethods} from "@mdxeditor/editor";
import {TextEditor} from "../../../../components/common/TextEditor";

const FORM_ITEM_NAME = {
  ID: 'id',
  TEST_ID: 'test_id',
  NAME: 'name',
  ANSWERS: 'answers',
  QUESTIONS: 'questions',
  DIFFICULTY: 'difficulty',
  IS_CORRECT: 'is_correct',
  INPUT_TYPE: 'input_type',
}

const ANSWER_TYPE = {
  CHECKBOX: 'checkbox',
  RADIO: 'radio',
}

const ACTION_NAME = {
  BEGIN: 'begin',
  REPEAT: 'repeat',
  ANSWER: 'answer',
  FINISH: 'finish'
}

const SEARCH_PARAMS = {
  IS_PROCTORING: 'isProctoring',
  PASSWORD: 'password',
}
export const ScheduleStudentTest = () => {
  const {t} = useTranslation("common")
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();

  const [testForm] = Form.useForm()
  const dispatch = useDispatch()
  const {testId, lessonId} = useParams()
  const ref = React.useRef<MDXEditorMethods>(null)

  const isProctoringSearchParams = searchParams.get(SEARCH_PARAMS.IS_PROCTORING)
  const passwordSearchParams = searchParams.get(SEARCH_PARAMS.PASSWORD)


  const {plans: {oneTest: oneTestState, testResult: testResultState}, common:{setForm}}: RootState = useSelector(selectStore)

  const [activeKey, setActiveKey] = useState<number>(0);

  useEffect(() => {
    if (testResultState.data) {
      if (testResultState.data.act === ACTION_NAME.BEGIN) {
        const test = testResultState.data?.question?.map((item: any) => ({id: item.id, [item.input_type]: null}))
        
        if(test.length){
          testForm.setFieldsValue({
            [FORM_ITEM_NAME.TEST_ID]: testId,
            [FORM_ITEM_NAME.QUESTIONS]: test
          })
        } else {
          message.error('Произошла ошибка!')
          // navigate(-1)
        }

      }
    } else {
      if(isProctoringSearchParams){
        dispatch(testBegin({
          test_id: testId,
          lesson_id: lessonId,
          onSuccess: () => {},
          test_password: passwordSearchParams || '***'
        }))
      } else {
        navigate(-1)
      }
    }
  }, [testResultState.data])


  const onChangeTab = (newActiveKey: number) => {
    setActiveKey(newActiveKey);

    //todo кастыль, я хз почему не работает иначе

    let value = testResultState.data?.question?.[newActiveKey]?.[FORM_ITEM_NAME.NAME]
    ref.current?.setMarkdown(value)
  }

  const handleFinish = () => {
    dispatch(setFormAction({
      method: "post",
      path: `sdot/test-process`,
      fields: {
        act: ACTION_NAME.FINISH,
        lesson_id: lessonId,
        th: oneTestState.data?.hash,
        rh: testResultState.data?.rh,
        successHandler: () => {
          dispatch(testBeginFail())
          dispatch(getQuestionAnswerActionFail())
          const path = {
            // @ts-ignore
            pathname: generatePath(ROUTE_PATH.STUDENTS_SCHEDULE_PLAN, {lessonId: lessonId}),
          }

          navigate(path);
        },
        successContent: (fio: string, res: string) => {
          return (
            <Row gutter={[16, 16]}>
              <Col span={24}>
                <MyText>
                  ФИО: {fio}
                </MyText>
              </Col>

              <Col span={24}>
                <MyText>
                  Оценка: {res}
                </MyText>
              </Col>
            </Row>
          )
        }
      },
      action: testEnd
    }))
  }

  const handleClickFinish = () => {
    let isAnsweredArray: any[] = testResultState.data?.question?.filter((item: any) => item.answers?.some((inner: any) => inner.isAnswer))
    let check = testResultState.data?.question?.length - isAnsweredArray.length

    Modal.confirm({
      title: t('endTest'),
      icon: null,
      centered: true,
      content: (
        <Row gutter={[16, 16]}>
          {
            check !== 0 &&
            <Col>
              <MyText size={18}>
                {t('unansweredTasksCount')}: <MyText color={Color.primary} size={20}>{check}</MyText>
              </MyText>
            </Col>
          }

          <Col>
            <MyText>
              {t('areYouSureYouWantToEndTheTest')}
            </MyText>
          </Col>
        </Row>
      ),
      cancelText: t('cancel'),
      okText: t('endTest'),
      okType: 'danger',
      onOk() {
        handleFinish()
        message.success(t('yourAnswersHaveBeenAccepted'))
      },
      onCancel() {
        Modal.destroyAll()
      }
    });
  }

  const handleClickSave = () => {
    const answer = testForm.getFieldsValue()?.questions?.[activeKey]
    let currentAnswer = answer?.[ANSWER_TYPE.RADIO] ? [{id: answer?.[ANSWER_TYPE.RADIO]}] : answer?.[ANSWER_TYPE.CHECKBOX]?.map((item: any) => ({id: item}))

    if (currentAnswer?.length) {
      let fields = {
        act: ACTION_NAME.ANSWER,
        th: testResultState.data?.th,
        rh: testResultState.data?.rh,
        lesson_id: lessonId,
        question: {
          id: testResultState.data?.question?.[activeKey]?.[FORM_ITEM_NAME.ID],
          answers: currentAnswer,
        }
      }

      dispatch(setFormAction({
        method: "post",
        path: `sdot/test-process`,
        fields: fields,
        action: testResultAction
      }))
    }
  }

  const difficultyContent = useMemo(() => {
    let current = testResultState.data?.question?.[activeKey]?.difficulty
    let array = [1, 2, 3]
    const color = current === 1 ? Color.success : current === 2 ? Color.warning : current === 3 ? Color.error : '#fff'
    const text = current === 1 ? t('easy') : current === 2 ? t('average') : current === 3 ? t('hard') : ''

    if (current) {
      return (
        <Popover title={(
          <Row gutter={[4, 4]} align='middle'>
            <Col>
              <MyText size={14} color={Color.icon}>
                {t('difficultyLevel')}:
              </MyText>
            </Col>
            <Col>
              <MyText size={14} color={Color.titleText} weight={500}>
                {text}
              </MyText>
            </Col>
          </Row>
        )}>
          <Row align='middle' gutter={[4, 4]}>
            {
              array.map((item, index) => (
                <Col key={item}>
                  <Badge color={current >= index + 1 ? color : Color.border}/>
                </Col>
              ))
            }
          </Row>
        </Popover>
      )
    }
  }, [activeKey])

  const timerContent = useMemo(() => {
    return (
      oneTestState.data?.time && (testResultState.data?.act === ACTION_NAME.BEGIN || testResultState.data?.act === ACTION_NAME.ANSWER) &&
      <Flex style={{ width: '100%'}}>
        <Timer minutes={oneTestState.data?.time} onCompleted={handleFinish}/>
      </Flex>
    )
  }, [oneTestState.data?.time, testResultState.data?.act])

  return (
    <>
      {
        !isProctoringSearchParams ?
          <MyBreadcrumb title={t('back')} isBack/>
          :
          <div style={{marginBottom: 20}}></div>
      }

      <Row justify='center'>
        <Col span={20}>
          <Row gutter={[16, 16]}>
            <Col span={18}>
              <Card loading={oneTestState.loading || testResultState.loading} title={(
                <Row justify='center'>
                  <Col>
                    <MyText size={16} weight={500}>
                      {t('questionCountNumber', {count: activeKey + 1})}
                    </MyText>
                  </Col>
                </Row>
              )}>
                <Form form={testForm}>
                  <Row gutter={[24, 24]}>
                    <Col span={24}>
                      <Alert type='info' message={(
                        <Row gutter={[8, 8]} align='middle'>
                          <Col>
                            <MyText color={Color.darkPress} size={14} weight={700}>
                              {t('testType')}:
                            </MyText>
                          </Col>
                          <Col>
                            {testResultState.data?.question?.[activeKey]?.[FORM_ITEM_NAME.INPUT_TYPE] === ANSWER_TYPE.RADIO ? t('singleCorrectAnswers') : t('multipleCorrectAnswers')}
                          </Col>
                        </Row>
                      )}/>
                    </Col>
                    <Col span={24}>
                      <MyText weight={500} size={24}>
                        <TextEditor
                          value={testResultState.data?.question?.[activeKey]?.[FORM_ITEM_NAME.NAME]}
                          disabled={true}
                          ref={ref}
                        />
                      </MyText>
                    </Col>
                    <Col span={24}>
                      <Form.List name={FORM_ITEM_NAME.QUESTIONS}>
                        {
                          (fields, operation, meta) => {
                            return (
                              fields.map((item, index) => {
                                  return (
                                    <Form.Item key={item.key}
                                               name={[item.key, testResultState.data?.question?.[activeKey]?.[FORM_ITEM_NAME.INPUT_TYPE]]}
                                               style={{display: activeKey === item?.key ? 'flex' : 'none'}}>
                                      {
                                        testResultState.data?.question?.[activeKey]?.[FORM_ITEM_NAME.INPUT_TYPE] === ANSWER_TYPE.RADIO ?
                                          (<Radio.Group>
                                            <Row gutter={[16, 16]}>
                                              {
                                                testResultState.data?.question?.[activeKey]?.[FORM_ITEM_NAME.ANSWERS]?.map((item: any) => (
                                                  <Col key={item.id} span={24}>
                                                    <Radio value={item.id}>
                                                      <TextEditor
                                                        value={item.name}
                                                        disabled={true}
                                                      />
                                                    </Radio>
                                                  </Col>
                                                ))
                                              }
                                            </Row>
                                          </Radio.Group>)
                                          :
                                          (<Checkbox.Group>
                                            <Row gutter={[16, 16]}>
                                              {
                                                testResultState.data?.question?.[activeKey]?.[FORM_ITEM_NAME.ANSWERS]?.map((item: any) => (
                                                  <Col key={item.id} span={24}>
                                                    <Checkbox value={item.id}>
                                                      <TextEditor
                                                        value={item.name}
                                                        disabled={true}
                                                      />
                                                    </Checkbox>
                                                  </Col>
                                                ))
                                              }
                                            </Row>
                                          </Checkbox.Group>)
                                      }
                                    </Form.Item>
                                  )
                                }
                              )
                            )
                          }
                        }

                      </Form.List>
                    </Col>
                    <Col span={24}>
                      <Row gutter={[32, 32]} justify='space-between' align={'middle'}>

                        <Col>
                          <MyButton onClick={() => {
                            onChangeTab(activeKey - 1)
                          }} disabled={!(activeKey !== 0)}>
                            {t('back')}
                          </MyButton>
                        </Col>

                        <Col>
                          <MyButton type='primary' onClick={() => {
                            if(testResultState.data?.question?.length !== (activeKey + 1)){
                              onChangeTab(activeKey + 1)
                            }
                            handleClickSave()
                          }} disabled={setForm.loading}>
                            {t('answering')}
                          </MyButton>
                        </Col>

                        <Col>
                          <MyButton disabled={!(testResultState.data?.question?.length !== (activeKey + 1))} type='primary' ghost onClick={() => {
                            onChangeTab(activeKey + 1)
                          }}>
                            {t('nextStep')}
                          </MyButton>
                        </Col>


                      </Row>
                    </Col>
                  </Row>
                </Form>
              </Card>
            </Col>

            <Col span={6}>
              <Card loading={oneTestState.loading || testResultState.loading}>
                <Row gutter={[24, 24]}>
                  <Col span={24}>
                    <Row gutter={[16, 16]} align='middle'>
                      <Col>
                        {difficultyContent}
                      </Col>

                      <Col flex={1}>
                        {timerContent}
                      </Col>
                    </Row>
                  </Col>
                  <Col span={24}>
                    <Flex wrap='wrap' gap={4}>
                      {
                        testResultState.data?.question?.map((item: any, index: any) => (
                          <Flex style={{
                            minWidth: 40,
                            minHeight: 40,
                            width: 40,
                            height: 40,
                            border: `1px solid ${activeKey === index ? Color.hover : item.answers?.some((inner: any) => inner.isAnswer) ? Color.primary : Color.border}`,
                            borderRadius: 8,
                            cursor: 'pointer',
                            background: activeKey === index ? Color.hover : item.answers?.some((inner: any) => inner.isAnswer) ? Color.hover : 'transparent'
                          }} key={item?.id} align='center' justify='center' onClick={() => {
                            onChangeTab(index)
                          }}>
                            <MyText color={activeKey === index ? '#fff' : item.answers?.some((inner: any) => inner.isAnswer) ? Color.primary : Color.subtitle}>
                              {index + 1}
                            </MyText>
                          </Flex>
                        ))
                      }
                    </Flex>
                  </Col>
                  <Col span={24}>
                    <Row justify='center'>
                      <Col>
                        <MyButton title={t('endTest')} danger ghost onClick={handleClickFinish}/>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Card>
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  )
}